module.exports = __webpack_public_path__ + "img/DRGN.d78503b5.svg";